import { Theme } from "@mui/material/styles";
import { CSSObject } from "tss-react/types";

export type InputColorClassKeys =
    | "root_primary"
    | "root_secondary"
    | "root_error"
    | "root_info"
    | "root_success"
    | "root_warning"
    | "root_notice"
    | "root_muted"
    | "root_white"
    | "root_black"
    | "root_inherit"
    | "under"
    | "under_primary"
    | "under_secondary"
    | "under_error"
    | "under_info"
    | "under_success"
    | "under_warning"
    | "under_notice"
    | "under_muted"
    | "under_white"
    | "under_black"
    | "under_inherit"
    ;

export const InputColorClasses = (theme: Theme): Record<InputColorClassKeys, CSSObject> => ({

    root_inherit: {
        color: 'inherit',
    },
    root_white: {
        color: theme.palette.common.white
    },
    root_black: {
        color: theme.palette.common.black
    },
    root_primary: {
        color: theme.palette.primary.dark
    },
    root_secondary: {
        color: theme.palette.secondary.dark
    },
    root_error: {
        color: theme.palette.error.dark
    },
    root_warning: {
        color: theme.palette.warning.dark
    },
    root_info: {
        color: theme.palette.info.dark
    },
    root_success: {
        color: theme.palette.success.dark
    },
    root_muted: {
        color: theme.palette.muted.main
    },
    root_notice: {
        color: theme.palette.notice.light
    },

    under: {
        "&:after": {
            borderBottomWidth: "1",
            borderBottomStyle: "solid"
        }
    },
    under_inherit: {
        "&:after": {
            borderBottomColor: "inherit"
        }
    },
    under_white: {
        "&:after": {
            borderBottomColor: theme.palette.common.white
        }
    },
    under_black: {
        "&:after": {
            borderBottomColor: theme.palette.common.black
        }
    },
    under_primary: {
        "&:after": {
            borderBottomColor: theme.palette.primary.dark
        }
    },
    under_secondary: {
        "&:after": {
            borderBottomColor: theme.palette.secondary.dark
        }
    },
    under_error: {
        "&:after": {
            borderBottomColor: theme.palette.error.dark
        }
    },
    under_warning: {
        "&:after": {
            borderBottomColor: theme.palette.warning.dark
        }
    },
    under_info: {
        "&:after": {
            borderBottomColor: theme.palette.info.dark
        }
    },
    under_success: {
        "&:after": {
            borderBottomColor: theme.palette.success.dark
        }
    },
    under_muted: {
        borderBottomColor: theme.palette.muted.main
    },
    under_notice: {
        borderBottomColor: theme.palette.notice.light
    },
});

